import { AppError } from '../errors/app-error.js';
/**
 * Invariantes del análisis. Se comprueban al construirlo, no al mostrarlo: un
 * borrador incoherente guardado es un borrador incoherente que alguien va a leer.
 */
export function assertAnalysisCoherent(props) {
    if (props.status !== 'ready')
        return;
    if (!props.suggestedDecision) {
        throw AppError.validation('A ready analysis must suggest a decision', 'cap.analysis_without_decision');
    }
    // Condiciones sin aprobación condicionada serían condiciones que nadie va a
    // aplicar: la decisión que las lleva es una sola.
    const proposesConditions = props.suggestedConditions.length > 0;
    const isConditional = props.suggestedDecision === 'approved_with_conditions';
    if (proposesConditions !== isConditional) {
        throw AppError.validation('Conditions belong to a conditional approval and to no other decision', 'cap.analysis_conditions_mismatch');
    }
    // Proponer aprobar CON CONDICIONES sin nombrarlas es simular rigor: el mismo
    // criterio que `assertConditions` aplica a la decisión real.
    if (isConditional && props.suggestedConditions.some((c) => !c.note.trim())) {
        throw AppError.validation('Every suggested condition needs its own note', 'cap.analysis_condition_without_note');
    }
}
/**
 * Si el análisis habla del paquete que el revisor tiene delante.
 *
 * Existe porque el centro puede presentar una versión nueva mientras el análisis
 * está guardado. Mostrar una sugerencia calculada sobre la versión 2 al lado de
 * la versión 3 es exactamente el modo de falla que ya costó tiempo: la pantalla
 * describiendo un estado que ya no es el actual.
 */
export function analysisIsStale(analysis, currentVersion) {
    return analysis.packetVersion !== currentVersion;
}
//# sourceMappingURL=cap-assisted-analysis.entity.js.map